export const user_menu = {
    en: [
        {
            icon: "far fa-user",
            content: "Profile"
        },
        {
            icon: "fas fa-wallet",
            content: "My Wallet"
        },
        {
            icon: "fas fa-cog",
            content: "Settings"
        },
        {
            icon: "fas fa-sign-out-alt",
            content: "Logout"
        }
    ],
    ru: [
        {
            icon: "far fa-user",
            content: "Профиль"
        },
        {
            icon: "fas fa-wallet",
            content: "Мой бумажник"
        },
        {
            icon: "fas fa-cog",
            content: "Настройки"
        },
        {
            icon: "fas fa-sign-out-alt",
            content: "Выйти"
        }
    ],
    uz: [
        {
            icon: "far fa-user",
            content: "Profil"
        },
        {
            icon: "fas fa-wallet",
            content: "Mening hamyonim"
        },
        {
            icon: "fas fa-cog",
            content: "Sozlamalar"
        },
        {
            icon: "fas fa-sign-out-alt",
            content: "Chiqish"
        }
    ],
}